import React, { useEffect, useMemo, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ITEM_PER_PAGE, PUBLIC_URL, SEARCH_DELAY } from "../../app.config";
import Pagination from "../../component/Pagination";
import SearchAndExport from "../../component/SearchAndExport";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import useDebounce from "../hooks/useDebounce";
import * as API from "../../utils/api.service";
import {
  ExportToCSV,
  ExportToExcel,
  ExportToPdf,
  handleNoDataFound,
  SWIT_DELETE,
  SWIT_DELETE_SUCCESS,
} from "../../utils/common.service";
import {
  getChallengeApiCall,
  editChallengeApiCall,
} from "../../Store/slices/challengeSlice";
import { PermissionContext } from "../../context/PermissionContext";
import Cookies from "js-cookie";

export default function ManageChallenge() {
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const debounce = useDebounce(search, SEARCH_DELAY);
   const [page, setPage] = useState(localStorage.getItem("currentPage") || 1);
  const [fieldSort, setFieldSort] = useState("id desc");
  const [ascSort, setAscSort] = useState(false);
  const [sortColumn, setSortColumn] = useState("id");
  const [fontDropdownOpen, setFontDropdownOpen] = useState(false);
  const [selectedFont, setSelectedFont] = useState(localStorage.getItem("challengeFontFilter") ?? "All");
  let userData = Cookies.get("dataCA")
    ? JSON.parse(Cookies.get("dataCA"))
    : null;
  const role = userData ? userData.role : null;
  const { permissions } = useContext(PermissionContext);

  const location = useLocation();
   const path = location.pathname;
   useEffect(() => {
     localStorage.setItem("modulePath", path);
     localStorage.setItem("currentPage", page);
   }, []);
 
   const handlePageChange = (newPage) => {
     localStorage.setItem("currentPage", newPage);
     setPage(newPage);
   };

  const handleSortChange = (fieldName, sort) => {
    if (sort === "asc") {
      setFieldSort(`${fieldName} ${sort}`);
      setSortColumn(fieldName);
      setAscSort(true);
    } else {
      setFieldSort(`${fieldName} ${sort}`);
      setSortColumn(fieldName);
      setAscSort(false);
    }
  };

  const {
    challengeList: { data: challengeList },
  } = useSelector((state) => state.challenge);

  //console.log('challengeList :', challengeList);

  useEffect(() => {
    handleCompanyListAPI();
  }, [page, debounce, fieldSort, selectedFont]);

  const handleCompanyListAPI = () => {
    let submitData = {
      search: debounce,
      page: page,
      fieldSort,
      font: selectedFont,
    };
    // let request = {};
    dispatch(getChallengeApiCall(submitData));
  };

  const handleStatusChange = async (id, currentStatus) => {
    //console.log("currentStatus :", currentStatus);
    dispatch(setLoader(true));
    const newStatus = currentStatus === "Active" ? "Inactive" : "Active";

    let submitData = { id, status: newStatus };

    try {
      await dispatch(editChallengeApiCall(submitData));
      dispatch(getChallengeApiCall({
        search: debounce,
        page: page,
        fieldSort: fieldSort,
      }));

      SWIT_DELETE_SUCCESS(`Status changed to ${newStatus} successfully`);
    } catch (error) {
      console.error("Error changing status:", error);
    } finally {
      dispatch(setLoader(false));
    }
  };

  const handleDeleteManage = async (id) => {
    SWIT_DELETE(`You won't be able to delete this!`).then(async (result) => {
      if (result?.isConfirmed) {
        dispatch(setLoader(true));
        let submitData = {
          id: id,
          status: "Deleted",
        };

        // console.log(
        //   "444444444444444444444444444444444444444444444444444444",
        //   submitData
        // );

        await dispatch(editChallengeApiCall(submitData));
        await handleCompanyListAPI();
        await SWIT_DELETE_SUCCESS(`Daily Challenge delete successfully`);
      }
    });
  };

  

  // const handleExportApiCall = async (type) => {
  //   dispatch(setLoader(true));
  //   let submitData = {
  //     search: debounce,
  //     fieldSort,
  //   };
  //   const { code, data } = await API.getClientExportListApi(submitData);
  //   if (code === "1") {
  //     if (type === "PDF") {
  //       ExportToPdf(data, "clientList", "Client List");
  //     } else if (type === "CSV") {
  //       ExportToCSV(data, "clientList");
  //     } else if (type === "EXCEL") {
  //       ExportToExcel(data, "clientList");
  //     }
  //   }
  //   dispatch(setLoader(false));
  // };

  // console.log("*****************************************",clientList);
  const companyListData = useMemo(() => {
    return challengeList?.map((item, index) => (
      <>
        <tr key={index}>
          <td>{item?.id}</td>
          <td>{item?.challenge_title}</td>
          <td>
            <img
              src={item?.latter_image}
              alt="Latter Image"
              style={{ width: "50px", height: "50px", objectFit: "contain" }}
            />
          </td>
          {/* <td>
            <img
              src={item?.background_image}
              alt="Background Image"
              style={{ width: "50px", height: "50px", objectFit: "cover" }}
            />
          </td> */}
          <td>{item?.image_title}</td>
          <td>{item?.created_by}</td>
          <td>{item?.points}</td>
          <td>{ item?.start_date || '-' }</td>
          <td>{ item?.end_date || '-' }</td>
          <td>{item?.challenge_type}</td>
          <td>{item?.font || "Ruqa"}</td>


          {role == "admin" ||
            (permissions[9]?.module_id === 10 &&
              permissions[9]?.permission_update === 1) ? (
                <td>
                <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`is_active_${item.id}`}
                  checked={item?.status === "Active"}
                  onChange={(e) => {
                    // console.log("e--------------------", e.target.value);
                    handleStatusChange(item?.id, item?.status);
                  }}
                />
              </div>
              </td>
            ) :<td>{item?.status}</td>}
            
          
          <td>
            {role == "admin" ||
            (permissions[9]?.module_id === 10 &&
              permissions[9]?.permission_view === 1) ? (
              <a
                className="text-reset fs-18 cursor_pointer"
                onClick={() =>
                  navigate(`/manage_challenge/view_challenge_details`, {
                    state: { challengeData: item },
                  })
                }
              >
                {" "}
                <i className="ri-eye-line"></i>
              </a>
            ) : null}

            {role == "admin" ||
            (permissions[9]?.module_id === 10 &&
              permissions[9]?.permission_update === 1) ? (
              <a
                className="text-reset fs-18 m-1 cursor_pointer"
                onClick={() =>
                  navigate(`/manage_challenge/edit_challenge`, {
                    state: { challengeData: item },
                  })
                }
              >
                {" "}
                <i className="ri-edit-line"></i>
              </a>
            ) : null}

            {role == "admin" ||
            (permissions[9]?.module_id === 10 &&
              permissions[9]?.permission_delete === 1) ? (
              <a
                className="text-reset fs-18 cursor_pointer"
                onClick={() => handleDeleteManage(item?.id)}
              >
                {" "}
                <i className="ri-delete-bin-6-line"></i>
              </a>
            ) : null}
          </td>
        </tr>
      </>
    ));
  }, [challengeList]);

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <SubNavbar title={`Manage Challenge`} header={`Challenge`} />

          {role == "admin" ||
          (permissions[9]?.module_id === 10 &&
            permissions[9]?.permission_add === 1) ? (
            <div className="col-sm-6 mb-2">
              <div className="d-flex justify-content-end align-items-center gap-3 flex-wrap">
                <button
                  type="button"
                  className="btn btn-soft-primary"
                  onClick={() => navigate(`/manage_challenge/add_challenge`)}
                >
                  <i className="ri-settings-2-line align-text-bottom me-1 fs-16 lh-1"></i>
                  Add Challenge
                </button>

                <div className="btn-group">
                  <button
                    type="button"
                    className="btn btn-soft-primary dropdown-toggle"
                    onClick={() => setFontDropdownOpen(!fontDropdownOpen)}
                  >
                    {selectedFont}
                  </button>

                  {fontDropdownOpen && (
                    <ul className="dropdown-menu show" style={{ right: 0, left: "auto" }}>
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => {
                            setSelectedFont("All");
                            localStorage.setItem("challengeFontFilter", "All");
                            setFontDropdownOpen(false);
                          }}
                        >
                          All
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => {
                            setSelectedFont("Ruqa");
                            localStorage.setItem("challengeFontFilter", "Ruqa");
                            setFontDropdownOpen(false);
                          }}
                        >
                          Ruqa
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => {
                            setSelectedFont("Naskh");
                            localStorage.setItem("challengeFontFilter", "Naskh");
                            setFontDropdownOpen(false);
                          }}
                        >
                          Naskh
                        </button>
                      </li>
                    </ul>
                  )}
                </div>
              </div>
            </div>
          ) : null}
          <div className="card rounded-3">
            <div className="card-body">
              <div className="rounded-3 mb-3">
                <SearchAndExport
                  searchFieldName={`Challenge`}
                  setSearch={setSearch} isExport={false}
                  // handleExportApiCall={handleExportApiCall}
                />
              </div>
              <div className="responsive-table-plugin">
                <div className="table-rep-plugin">
                  <div
                    className="table-responsive"
                    data-pattern="priority-columns"
                  >
                    {Object.keys(challengeList)?.length > 0 ? (
                      <>
                        <table
                          id="tech-companies-1"
                          className="table table-centered mb-0 table-hover "
                        >
                          <thead>
                            <tr>
                              <th
                                scope="col"
                                className={`cursor_pointer bi ${
                                  sortColumn === "id"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "id",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Id
                              </th>

                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "challenge_title"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "challenge_title",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Challenge Title
                              </th>

                              <th scope="col">Letter Image</th>

                              {/* <th>BackGround Image</th> */}
                              <th>Image Title</th>
                              <th>Created By</th> 
                              <th>Points</th>
                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "start_date"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "start_date",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Start Date
                              </th>

                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "end_date"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "end_date",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                End Date
                              </th>
                              <th>Challenge Type</th>
                              <th>Font</th>

                              <th
                                scope="col"
                                className={`cursor_pointer bi ${
                                  sortColumn === "status"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "status",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Status
                              </th>

                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>{companyListData}</tbody>
                        </table>
                      </>
                    ) : (
                      <>{handleNoDataFound("Challenges")}</>
                    )}
                  </div>
                  <Pagination
                    per_page={ITEM_PER_PAGE}
                    pageCount={challengeList[0]?.challenges_count}
                    onPageChange={handlePageChange}
                    page={page}
                    lableName={`Challenges`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
